import React, { useState } from "react";
import { StriimButton } from "@striim/striim-ui";
import { ArrowForward } from "../../../../../generic/icon/customIcons";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import { optionsType } from "./create-app-page-app-type-dropdown";
import { adapterType } from "../create-app-page-templates";
import { recentlyUsedAdaptersService } from "../services";
import Tracker from "../../../../../../core/services/tracker/tracker";
import DraftAdaptersSelectionModal, { DraftWizardsTypes } from "./create-app-page-draft-adapter-modal";

interface propsTypes {
    templateInfo: optionsType;
    sourceAdapter: adapterType;
    targetAdapter: adapterType;
    isTopologyUnSupported: boolean;
}

const CreateAppPageGetStartedButton: React.FunctionComponent<propsTypes> = ({
    templateInfo,
    sourceAdapter,
    targetAdapter,
    isTopologyUnSupported
}) => {
    const navigate = useNavigate();
    const [draftWizards, setDraftWizards] = useState<DraftWizardsTypes[]>([]);
    const [isDraftsAvailable, setIsDraftsAvailable] = useState<Boolean>(false);

    async function handleSubmit(): Promise<void> {
        recentlyUsedAdaptersService.add({
            sourceAdapter: sourceAdapter.value,
            targetAdapter: targetAdapter.value
        });

        // DRAFT_WIZARD  
        // Disabling the draft wizard feature temporarily, add back the commented api call to resume it.
        
        // const draftWizards = await createAppUtils.getAllDraftWizard(templateInfo?.url);
        // if (draftWizards?.length) {
        //     setIsDraftsAvailable(true);
        //     setDraftWizards(draftWizards);
        // } else {
        //     templateInfo?.url && navigate(templateInfo?.url);
        // }

        // DRAFT_WIZARD
        // Remove it when adding above draft wizard code.
        templateInfo?.url && navigate(templateInfo?.url);


        Tracker.getInstance().track("create-app-template", {
            event: "Create App:Template:Clicked",
            template: `${sourceAdapter.value} to ${targetAdapter.value}`,
            isAutomatedILCDC: templateInfo?.value === "AUTOMATEDILCDC"
        });
    }
    if (isTopologyUnSupported) {
        return null;
    }
    return (
        <Grid item alignSelf="flex-start" sx={{ width: "500px" }}>
            <StriimButton
                variant="primary"
                disabled={!templateInfo?.url}
                data-test-id="create-app-get-started-button"
                onClick={handleSubmit}
                endIcon={<ArrowForward />}
            >
                Get Started
            </StriimButton>
            <DraftAdaptersSelectionModal
                isDraftsAvailable={isDraftsAvailable}
                setIsDraftsAvailable={setIsDraftsAvailable}
                templateInfo={templateInfo}
                draftWizards={draftWizards}
                sourceAdapterInfo={sourceAdapter}
                targetAdapterInfo={targetAdapter}
            ></DraftAdaptersSelectionModal>
        </Grid>
    );
};

export default CreateAppPageGetStartedButton;
